module.exports = require(`../../${process.env.MAIN_MODULE}/_config/common/reducers`)
